import * as $ from 'jquery';

import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';

import { isMobilePage } from 'lib/util/helpers';

/**
 * SectionAnchorStage module implementation.
 *
 * @author tzhveig1
 * @class SectionAnchorStage
 * @extends Tc.Module
 */
export default class SectionAnchorStage extends Module {
	private $anchors! : JQuery;

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 */
	public on(callback : Hook) {
		this.$anchors = this.$ctx.find('a');
		this.$anchors.on('click', smoothScroll);
		callback();
	}
}

function smoothScroll(event : any) {
	const $target = $(event.target.hash);
	if ($target.length > 0) {
		const offset = $target.offset();
		if (offset !== undefined) {
			event.preventDefault();
			let additionalOffset = (isMobilePage() || $target.is(':target')) ? 0 : 140;
			const crisisHeader = document.querySelector('.crisis');
			if (crisisHeader !== null) {
				additionalOffset += parseInt(window.getComputedStyle(crisisHeader).height, 10);
			}
			$('html, body').animate({scrollTop: offset.top - additionalOffset}, 1000,
				() => window.location.hash = event.target.hash.slice(1));
		}
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/sdx/Tc.Module.SectionAnchorStage.ts